import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import {Scroll} from 'vuetify/lib/directives';

Vue.use(Vuetify, {
  directives:{Scroll},
  iconfont: 'fa',
  theme: {
    primary: "#f6a027"
  }
})
